import _Object$keys from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/web.dom.iterable";
import _getIterator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/get-iterator";
import "core-js/modules/es6.function.name";
import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import vipGetReportBtn from "@/components/vipGetReportBtn/vipGetReportBtn.vue";
import { sendMapEvent } from "@/utils/analytics"; // import stars from "./stars/stars.vue";
// import starsSky from "./stars/starsSky.vue";

import backTrack, { VIP_CLOSE_TOAST } from "@/utils/backTrack";
import GeneralUtilsHelper from "@/utils/generalUtils";
import Reval from "./reval/reval.vue";
import { i18n } from "@/i18n/i18n-setup";
import EventBus from "@/utils/eventBus";
import VideoPlayer from "@/components/videoPlayer/videoPlayer.vue";
import { isIos } from "@/utils/lodash";

var VipPage =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipPage, _Vue);

  function VipPage() {
    var _this;

    _classCallCheck(this, VipPage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipPage).apply(this, arguments));
    _this.activetedIndex = 0;
    _this.swiperItemHeight = 0;
    _this.swiperItemWidth = 0;
    _this.isShowCloseIcon = false;
    _this.key = "";
    _this.agingShutterVideo = "";
    _this.futureBabyVideo = "";
    _this.loveCompatibilityVideo = "";
    _this.palmPrintReadingVideo = "";
    _this.swiper = null;
    _this.renderVideoList = [];
    _this.videoList = null;
    _this.currentIndex = 0;
    _this.videoMap = {
      futureBaby: {
        key: 'futureBaby',
        videoPoster: _this.$remoteImg('icons/futureBaby/fb_index.jpg')
      },
      palmPrintReading: {
        key: 'palmPrintReading',
        videoPoster: _this.$remoteImg('vip/palmprint_firstframe.png')
      },
      agingShutter: {
        key: 'agingShutter',
        videoPoster: _this.$remoteImg('icons/vip/vip_as_index.jpg')
      },
      loveCompatibility: {
        key: 'loveCompatibility',
        videoPoster: _this.$remoteImg('vip/palmprint_firstframe.png')
      }
    };
    return _this;
  }

  _createClass(VipPage, [{
    key: "buyVIP",
    value: function () {
      var _buyVIP = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.sendEvent("click");
                _context.next = 4;
                return this.payVip();

              case 4:
                result = _context.sent;

                if (result) {
                  sendMapEvent("uia_vip_buyway", {
                    key: this.key
                  });
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                  this.goBack();
                  this.sendEvent("buy");
                } else {
                  _Toast("".concat(i18n.t("common.toast.payment_failed")));
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function buyVIP() {
        return _buyVIP.apply(this, arguments);
      }

      return buyVIP;
    }()
  }, {
    key: "sendEvent",
    value: function sendEvent(name) {
      sendMapEvent(this.key, {
        key: name
      });
    }
  }, {
    key: "videoEnded",
    value: function videoEnded(val) {
      var nextIndex = val + 1 < 4 ? val + 1 : 0;
      this.swiper.swipeTo(nextIndex);
      this.currentIndex = nextIndex;
      this.videoPlay(nextIndex);
    }
  }, {
    key: "clickClose",
    value: function clickClose() {
      var _this2 = this;

      if (!this.isShowCloseIcon) {
        return;
      }

      backTrack.listen({
        key: VIP_CLOSE_TOAST,
        fn: function fn() {
          _this2.hideVipToast();
        }
      });
      this.showCloseToast();
    }
  }, {
    key: "hideVipToast",
    value: function hideVipToast() {
      backTrack.destroy(VIP_CLOSE_TOAST);
      EventBus.$emit("vip-toast-show", {
        show: false
      });
    }
  }, {
    key: "toastBuyVIP",
    value: function () {
      var _toastBuyVIP = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                sendMapEvent('uia_vip_before_unload_dialog', {
                  key: 'click'
                });
                _context2.next = 4;
                return this.payVip();

              case 4:
                result = _context2.sent;

                if (result) {
                  sendMapEvent('uia_vip_before_unload_dialog', {
                    key: 'buy'
                  });
                  sendMapEvent("uia_vip_buyway", {
                    key: 'before_unload_dialog'
                  });
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                  this.goBack();
                } else {
                  _Toast("".concat(i18n.t("common.toast.payment_failed")));
                }

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function toastBuyVIP() {
        return _toastBuyVIP.apply(this, arguments);
      }

      return toastBuyVIP;
    }()
  }, {
    key: "showCloseToast",
    value: function showCloseToast() {
      backTrack.destroy(VIP_CLOSE_TOAST);
      this.showVipToast({
        confirmFn: this.toastBuyVIP,
        cancelFn: this.goBack
      });
    }
  }, {
    key: "goBack",
    value: function goBack() {
      backTrack.destroy(this.$route.name);
      this.routerGoBack(-1);
      this.hideVipToast();
    }
  }, {
    key: "videoPlay",
    value: function videoPlay(index) {
      var videoEle = document.querySelector(".video" + index);

      if (videoEle) {
        var promise = videoEle.play();

        if (promise !== undefined) {
          promise.catch(function (error) {// console.log("// Auto-play was prevented");
          }).then(function () {// console.log("Auto-play started");
          });
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(index) {
      try {
        this.currentIndex = index;
        var videoList = document.querySelectorAll('.video');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(videoList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var j = _step.value;

            if (j && !j.paused) {
              j.pause();
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        this.videoPlay(index);
      } catch (err) {
        console.log("video play", err);
      }
    }
  }, {
    key: "getVideoList",
    value: function getVideoList() {
      var _this3 = this;

      // const vedio_list: any = []
      // console.log('get lang',getLang())
      if (this.videoList && this.videoList.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _getIterator(this.videoList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var j = _step2.value;

            if (this.videoMap[j]) {
              this.videoMap[j].videoSrc = this[j + 'Video']; // this.videoMap[j].text = i18n.t(this.videoMap[j].text)

              this.renderVideoList.push(this.videoMap[j]);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else {
        _Object$keys(this.videoMap).forEach(function (item) {
          _this3.videoMap[item].videoSrc = _this3[item + 'Video']; // this.videoMap[item].text = i18n.t(this.videoMap[item].text)

          _this3.renderVideoList.push(_this3.videoMap[item]);
        });
      } // return this.renderVideoList;


      console.log('this.renderVideoList', this.renderVideoList);
    }
  }, {
    key: "getVideos",
    value: function () {
      var _getVideos = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var videoType;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                videoType = this.lunchConfig && this.lunchConfig.launch_vip_video_local_resource ? "local" : "online";
                _context3.next = 3;
                return GeneralUtilsHelper.getVideoFileUrl("future_baby.mp4", videoType);

              case 3:
                this.futureBabyVideo = _context3.sent;
                _context3.next = 6;
                return GeneralUtilsHelper.getVideoFileUrl("age_shutter.mp4", videoType);

              case 6:
                this.agingShutterVideo = _context3.sent;
                _context3.next = 9;
                return GeneralUtilsHelper.getVideoFileUrl("love_compatibility.mp4", videoType);

              case 9:
                this.loveCompatibilityVideo = _context3.sent;
                _context3.next = 12;
                return GeneralUtilsHelper.getVideoFileUrl("palm_print.mp4", videoType);

              case 12:
                this.palmPrintReadingVideo = _context3.sent;
                this.getVideoList();

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getVideos() {
        return _getVideos.apply(this, arguments);
      }

      return getVideos;
    }()
  }, {
    key: "calcSwiper",
    value: function calcSwiper() {
      var screenHeight = document.documentElement.offsetHeight;
      var screenWidth = document.documentElement.offsetWidth;
      this.swiperItemWidth = Math.floor(320 / 375 * screenWidth) + 20;
      this.swiperItemHeight = Math.floor(this.swiperItemWidth * 3 / 4) + 36;
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this4 = this;

      this.key = this.$route.query.key;
      this.videoList = this.$route.query.videoList;
      var closeIconShowTime = this.settingData && this.settingData.client && this.settingData.client.vip_config ? this.settingData.client.vip_config.vip_close_btn_delay_show_time : 2000;
      setTimeout(function () {
        _this4.isShowCloseIcon = true;
      }, closeIconShowTime);
    }
  }, {
    key: "created",
    value: function created() {
      this.calcSwiper();
      this.initData();
      this.getVideos();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this5 = this;

      this.sendEvent("show");
      backTrack.listen({
        key: this.$route.name,
        fn: function fn() {
          _this5.clickClose();
        }
      });
      this.$nextTick(function () {
        _this5.swiper = _this5.$refs.vantswipe;
      });

      if (isIos()) {
        document.addEventListener("resume", this.playVideo, false);
      }
    }
  }, {
    key: "playVideo",
    value: function playVideo() {
      this.videoPlay(this.currentIndex);
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      document.removeEventListener("resume", this.playVideo, false);
    }
  }, {
    key: "vedioText",
    get: function get() {
      return {
        futureBaby: i18n.t('home_page.main_function_list.future_baby'),
        palmPrintReading: i18n.t('home_page.main_function_list.palm_print_reading'),
        agingShutter: i18n.t('home_page.main_function_list.aging_shutter'),
        loveCompatibility: i18n.t('home_page.main_function_list.love_compatibility')
      };
    }
  }, {
    key: "getText",
    get: function get() {
      return i18n.t("common.button.try_for_free");
    }
  }, {
    key: "countTimes",
    get: function get() {
      return this.settingData && this.settingData.client && this.settingData.client.vip_config ? this.settingData.client.vip_config.vip_count_down_time / 1000 : 120;
    }
  }]);

  return VipPage;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], VipPage.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.PAY_VIP)], VipPage.prototype, "payVip", void 0);

tslib_1.__decorate([Mutation(types.HIDE_TOAST)], VipPage.prototype, "hideToast", void 0);

tslib_1.__decorate([Action(types.SHOW_VIP_TOAST)], VipPage.prototype, "showVipToast", void 0);

tslib_1.__decorate([Getter(types.GETTER_SETTING_DATA)], VipPage.prototype, "settingData", void 0);

tslib_1.__decorate([Getter(types.GETTER_LAUNCH_CONFIG)], VipPage.prototype, "lunchConfig", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], VipPage.prototype, "updateResultByName", void 0);

VipPage = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    vipGetReportBtn: vipGetReportBtn,
    // stars,
    Reval: Reval,
    VideoPlayer: VideoPlayer
  }
})], VipPage);
export default VipPage;